import BootstrapSwitchButton from "bootstrap-switch-button-react";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { statusToggleFunc } from "../../customHooks";
import { DeleteIcon, EditIcon } from "../../Icon";
import Loader from "../loader/Loader";
import {
  emptyTableData,
  projectDataStart,
  projectDataSuccess,
} from "../../redux/actions/MasterActions";
import Pagination from "../Reuseablecomponent/Pagination";
import SearchHeader from "../Reuseablecomponent/SearchHeader";
import DeleteModal from "./Modals/DeleteModal";
import ProjectModal from "./Modals/ProjectModal";

const ViewProject = () => {
  const { id } = useParams();
  const { project, isDataFetch, pageCount, message } = useSelector(
    (state) => state.master["project"]
  );
  const [isOpen, setIsOpen] = useState(false);
  const [data, setData] = useState([]);
  const dispatch = useDispatch();
  const [isdeletemodal, setIsdeletemodal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [reload, setReload] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [pageSize, setPageSize] = useState(10);
  const [pageNo, setPageNo] = useState(1);
  const getSearchValue = (value) => {
    setSearchValue(value);
  };
  const openModal = (e, value) => {
    setIsOpen(true);
    setData(value);
  };
  const closeModal = () => {
    setIsOpen(false);
  };
  const openDeleteModal = (id) => {
    setIsdeletemodal(true);
    setDeleteId(id);
  };
  const closeDeleteModal = () => {
    setIsdeletemodal(false);
    setDeleteId(null);
  };
  const handleActiveUser = async (value, id) => {
    statusToggleFunc("os", id, setReload, value);
  };
  const deletePropsConfig = {
    closeDeleteModal,
    isdeletemodal,
    closeModal,
    url: `project/admin/${id}`,
    deleteId: deleteId,
    setReload,
  };
  const crudConfig = {
    title: "Project",
    isOpen,
    closeModal,
    data,
    url: `project/admin/${id}`,
    setReload,
  };
  const paginationProps = {
    setPageNo,
    pageSize,
    setPageSize,
    pageCount,
  };
  useEffect(() => {
    let cleanUPData = [];
    dispatch(projectDataStart(id, searchValue, pageNo, pageSize));
    return () => {
      dispatch(emptyTableData(cleanUPData, 0, "success"));
    };
  }, [searchValue, pageNo, pageSize, reload]);
  return (
    <div className="userProject">
      <SearchHeader
        title="Project"
        openModal={openModal}
        getSearchValue={getSearchValue}
        setPageNo={setPageNo}
      />
      {isOpen && <ProjectModal {...crudConfig} />}
      {isdeletemodal && <DeleteModal {...deletePropsConfig} />}
      <div className="usertab">
        <div className="users">
          <table className="users__table">
            <thead className="users__table--thead">
              <tr>
                <th>Project Name</th>
                <th>Description</th>
                <th>Responsibilities</th>
                <th>Technical Stack</th>
                <th>Team Size</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody className="users__table--tbody">
              {isDataFetch ? (
                <tr>
                  <td colSpan={6}>
                    <Loader />
                  </td>
                </tr>
              ) : project.length === 0 ? (
                <tr>
                  <td
                    colSpan={3}
                    style={{ textAlign: "center", color: "red" }}
                  ></td>
                </tr>
              ) : (
                project.map((data) => (
                  <tr key={data.id}>
                    <td>{data.name}</td>
                    {data.description === null ? (
                      <td>-</td>
                    ) : (
                      <td>{data.description}</td>
                    )}{" "}
                    {/* {console.log("data", data)} */}
                    <td>{data.responsibilities}</td>
                    <td>{data.technicalStack}</td>
                    <td>{data.teamSize}</td>
                    <td>
                      <EditIcon openModal={openModal} data={data} />
                      <DeleteIcon
                        openDeleteModal={openDeleteModal}
                        enable={true}
                        data={data}
                      />
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
      <Pagination {...paginationProps} />{" "}
    </div>
  );
};

export default ViewProject;
